import {
  isValidSpanishTaxId,
  looksLikeSpanishTaxId,
  spanishDomesticBodyForComparison
} from '@/utils/spanishTaxId'

export function normalizeVatNumber(vat?: string | null): string {
  return (vat ?? '').trim().toUpperCase().replace(/[^A-Z0-9]/g, '')
}

export function isValidVatNumber(vat?: string | null): boolean {
  const normalized = normalizeVatNumber(vat)
  if (!normalized || !/^[A-Z0-9]{2,20}$/.test(normalized)) {
    return false
  }
  if (looksLikeSpanishTaxId(normalized)) {
    return isValidSpanishTaxId(normalized)
  }
  return true
}

export function vatComparisonKey(vat?: string | null): string {
  const normalized = normalizeVatNumber(vat)
  if (!normalized) {
    return ''
  }
  const spanishDomestic = spanishDomesticBodyForComparison(normalized)
  if (spanishDomestic) {
    return spanishDomestic
  }
  return normalized
}

export function vatLookupVariants(vat?: string | null): string[] {
  const normalized = normalizeVatNumber(vat)
  if (!normalized) {
    return []
  }
  const spanishDomestic = spanishDomesticBodyForComparison(normalized)
  if (spanishDomestic) {
    return [spanishDomestic, `ES${spanishDomestic}`]
  }
  return [normalized]
}
